import axios from "axios";
import { getToken } from "../Utils/util";
import { config } from "../Config/config";

export const instance = axios.create({
  baseURL: config.base.url,
});

instance.interceptors.request.use(
  (config) => {
    const Userdata = getToken();
    if (Userdata?.Token) {
      config.headers.Authorization = `Bearer ${Userdata.Token}`;
    }

    config.headers.Accept = config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => Promise.reject(error)
);

export const multipartInstance = axios.create({
  baseURL: config.base.url,
});

multipartInstance.interceptors.request.use(
  (config) => {
    const Userdata = getToken();
    if (Userdata?.Token) {
      config.headers.Authorization = `Bearer ${Userdata.Token}`;
    }

    config.headers["Content-Type"] = "multipart/form-data";
    config.headers.Accept = "application/json";

    return config;
  },
  (error) => Promise.reject(error)
);

// export default instance;
